import * as React from 'react';
import {Typography, Container, Box, Grid, Button, Stack} from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import PersonIcon from '@mui/icons-material/Person';
import ChatIcon from '@mui/icons-material/Chat';
import SendIcon from '@mui/icons-material/Send';
import {secured as axios} from '../../axios';
import {useNavigate} from 'react-router-dom';
import {formatPhoneNumber} from '../Service';
import {useState} from 'react';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import CircularProgress from '@mui/material/CircularProgress';
import {isMailValid} from '../Service';

const EstablishmentContact = ({establishment, header}) => {
  const navigate = useNavigate();
  const [borderName, setBorderName] = useState('');
  const [borderEmail, setBorderEmail] = useState('');
  const [borderMessage, setBorderMessage] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [text, setText] = useState('');
  const [phone, setPhone] = useState('');
  const {mode} = useDarkMode();
  const [successMessageVisible, setSuccessMessageVisible] = useState(false);
  const [errorMessageVisible, setErrorMessageVisible] = useState(false);
  const [isLoading, setIsloading] = useState(false);

  const validateData = (name, email, phone, text) => {
    if (name == '') {
      setBorderName('borderPink');
    }
    if (!isMailValid(email)) {
      setBorderEmail('borderPink');
    }
    if (text == '') {
      setBorderMessage('borderPink');
    }
    if (name == '' || email == '' || phone == '' || text == '') {
      return false;
    }
    return true;
  };
  const handleSubmit = event => {
    event.preventDefault();
    setSuccessMessageVisible(false);
    setErrorMessageVisible(false);
    if (validateData(name, email, phone, text) && !isLoading) {
      setIsloading(true);
      axios
        .post(
          `${axios.defaults.apiURL}/contact`,
          {
            person: {
              name: name,
              email: email,
              contact: phone,
            },
            establishement: {
              email: establishment.email_contact.text,
              name: establishment.name.text,
            },
            message: text,
          },
          header,
        )
        .then(function (response) {
          setName('');
          setPhone('');
          setEmail('');
          setText('');
          setSuccessMessageVisible(true);
          setIsloading(false);
        })
        .catch(function (error) {
          setErrorMessageVisible(true);
          setIsloading(false);
        });
    }
  };
  return (
    <Box>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '5px',
        }}>
        <div id="contactPhone">
          <div
            style={{
              fontFamily: 'DM sans',
              fontWeight: 700,
              fontSize: 23,
              marginBottom: 20,
            }}>
            <Typography variant={'subtitle7'}>
              Nous contacter par Téléphone
            </Typography>
          </div>
          <div id="contactPhoneContainer">
            <LocalPhoneIcon
              role="img"
              aria-label={"Numéro téléphone de l'établissement"}
              style={{fontSize: 50}}></LocalPhoneIcon>
            <a
              aria-label={"Appeler l'établissement"}
              className={'phoneLink'}
              style={{
                fontFamily: 'DM Sans',
                fontSize: 24,
                fontWeight: 400,
                marginTop: 10,
                marginRight: 0,
              }}
              href={`tel:'${establishment.phone.text}`}>
              {formatPhoneNumber(establishment.phone.text)}
            </a>
            <div style={{maxWidth: 300, marginLeft: 10}}>
              <Typography variant={'subtitle3'}>
                Standard ouvert du lundi au vendredi{' '}
              </Typography>
              <Typography variant={'subtitle3'}>
                de 9h à 12h et de 14h à 17h
              </Typography>
            </div>
          </div>
        </div>
        <div
          id="contactChat"
          style={{backgroundColor: mode.settings.cardBackgroundColor}}>
          <Typography variant={'h3'} style={{color: mode.settings.textColor6}}>
            Nous contacter directement via la plateforme
          </Typography>
          <Button
            className="buttonOhs"
            startIcon={
              <ChatIcon
                role="img"
                aria-label={"Accéder à la messagerie de l'établissement"}
              />
            }
            style={{marginTop: 20}}>
            <Typography variant={'subtitle3'}>
              Accéder à la messagerie
            </Typography>
          </Button>
        </div>
      </Box>
      <br />
      <Typography
        component={'form'}
        class={'inputComment'}
        onSubmit={handleSubmit}
        id="contactEmail"
        style={{backgroundColor: mode.settings.cardBackgroundColor}}>
        <Typography variant={'h3'} style={{color: mode.settings.textColor6}}>
          Nous contacter par mail
        </Typography>
        <br />
        <br />
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          spacing={{xs: 0, md: 0, lg: 2}}
          width={'100%'}>
          <div style={{flexDirection: 'column', width: '100%'}}>
            <Typography
              variant={'subtitle3'}
              style={{color: mode.settings.textColor3}}
              component={'label'}
              id={'label-name'}
              htmlFor={'name'}
            >
              Votre nom et prénom <sup class={'supContact'}>*</sup>
            </Typography>
            <div className={'inputIconContainer'}>
              <PersonIcon
                role="img"
                aria-label={'Champ nom et prénom'}
                className={'inputIcon'}></PersonIcon>
              <input
                aria-label={'Champ nom et prénom du formulaire'}
                type={'text'}
                className={'inputGrey' + ' ' + borderName}
                placeholder={'Ecrire ici votre nom et prénom'}
                value={name}
                onFocus={() => setBorderName('')}
                onChange={event => setName(event.target.value)}
                style={{
                  color: mode.settings.textColor3,
                  backgroundColor: mode.settings.inputBackgroundColor,
                }}
                id={'name'}
              />
              {borderName !== '' ? (
                <span className="tooltiptext" id="tooltipdemo">
                  Veuillez remplir ce champ.
                </span>
              ) : (
                <div></div>
              )}
            </div>
          </div>
          <div style={{width: '100%', margin: 0}}>
            <Typography
              variant={'subtitle3'}
              style={{color: mode.settings.textColor3}}
              component={'label'}
              id={'label-email'}
              htmlFor={'email'}
            >
              Votre adresse mail <sup className={'supContact'}>*</sup>
            </Typography>
            <div className={'inputIconContainer'}>
              <ChatIcon
                role="img"
                aria-label={'Champ email'}
                className={'inputIcon'}></ChatIcon>
              <input
                aria-label={'Champ email du formulaire'}
                type={'mail'}
                className={'inputGrey' + ' ' + borderEmail}
                placeholder={'Ecrire ici votre adresse e-mail'}
                value={email}
                onFocus={() => setBorderEmail('')}
                onChange={event => setEmail(event.target.value)}
                style={{
                  color: mode.settings.textColor3,
                  backgroundColor: mode.settings.inputBackgroundColor,
                }}
                id={'email'}
              />
              {borderEmail !== '' ? (
                <span className="tooltiptext" id="tooltipdemo">
                  Email invalide.
                </span>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </Stack>
        <div style={{width: '100%'}}>
          <Typography
            variant={'subtitle3'}
            style={{color: mode.settings.textColor3}}
            component={'label'}
            id={'label-phone'}
            htmlFor={'phone'}
          >
            Votre numéro de téléphone
          </Typography>
          <div className={'inputIconContainer'}>
            <LocalPhoneIcon
              role="img"
              aria-label={'Champ numéro téléphone'}
              className={'inputIcon'}></LocalPhoneIcon>
            <input
              aria-label={'Champ numéro téléphone du formulaire'}
              type={'number'}
              className="inputGrey"
              placeholder={'XX-XX-XX-XX'}
              value={phone}
              onChange={event => setPhone(event.target.value)}
              style={{
                color: mode.settings.textColor3,
                backgroundColor: mode.settings.inputBackgroundColor,
              }}
              id={'phone'}
            />
          </div>
        </div>
        <div style={{width: '100%'}}>
          <Typography
            variant={'subtitle3'}
            style={{color: mode.settings.textColor3}}
            component={'label'}
            id={'label-message'}
            htmlFor={'message'}
          >
            Votre message<sup className={'supContact'}>*</sup>
          </Typography>
          <div className={'inputIconContainer'}>
            <textarea
              aria-label={'Champ message du formualire'}
              value={text}
              type={'text'}
              className={'inputGreyArea' + ' ' + borderMessage}
              placeholder={'Ecrire votre message ici '}
              style={{
                height: 150,
                textAlign: 'left',
                paddingLeft: 20,
                color: mode.settings.textColor3,
                backgroundColor: mode.settings.inputBackgroundColor,
              }}
              onFocus={() => setBorderMessage('')}
              onChange={event => setText(event.target.value)}
              id={'message'}
            />
            {borderMessage !== '' ? (
              <span
                className="tooltiptext"
                id="tooltipdemo"
                style={{bottom: '104%', left: '63%'}}>
                Veuillez remplir ce champ.
              </span>
            ) : (
              <div></div>
            )}
          </div>
        </div>
        <Typography
          variant={'subtitle3'}
          style={{color: mode.settings.textColor6}}>
          <sup className={'supContact'}>*</sup> Ces champs sont obligatoires
        </Typography>
        {successMessageVisible && (
          <Typography
            variant={'subtitle3'}
            style={{color: mode.settings.textColor4, margin: 'auto'}}>
            Votre message a été envoyé
          </Typography>
        )}
        {errorMessageVisible && (
          <Typography
            variant={'subtitle3'}
            style={{color: mode.settings.textColor4, margin: 'auto'}}>
            Echec de l'envoi de votre message
          </Typography>
        )}
        <Button
          className="buttonOhs"
          startIcon={
            isLoading ? (
              <CircularProgress color="inherit" size={30} />
            ) : (
              <SendIcon role="img" aria-label={'Envoyer le formulaire'} />
            )
          }
          type="submit"
          style={{marginLeft: 'auto', marginRight: 9}}>
          <Typography variant={'subtitle3'}>Envoyer</Typography>
        </Button>
      </Typography>
    </Box>
  );
};

export default EstablishmentContact;
